import React, { Component } from 'react';
import { connect } from 'react-redux';

import { closeModal } from '../modules/active_modal';
import { setActiveFeaturedSelection } from '../modules/active_featured_selection';
import { navigate } from '../modules/high_level_actions';

import ProductDetail from './ProductDetail.jsx';


class ModalFeaturedSelection extends Component {

    constructor(props) {
        super(props);
        this.numfeaturedSelection = this.props.storeType == "Negative Option" ? 2 : 3;
        this.stepThroughFeaturedSelections = this.stepThroughFeaturedSelections.bind(this);
    }

    stepThroughFeaturedSelections(direction) {
        let activeFeaturedSelectionKey = this.props.featured.reduce((acc,cur, i)=>cur.id===this.props.activeFeaturedSelection.id ? i : acc, null),
            numfeaturedSelection = this.numfeaturedSelection - 1;
        if (direction === 'backward') {
            if (activeFeaturedSelectionKey > 0){
                activeFeaturedSelectionKey -= 1;
            } else {
                activeFeaturedSelectionKey = numfeaturedSelection;
            }
        } else {
            if (activeFeaturedSelectionKey < numfeaturedSelection){
                activeFeaturedSelectionKey += 1;
            } else {
                activeFeaturedSelectionKey = 0;
            }
        }
        let newActiveFeaturedSelection = this.props.featured.reduce((acc,cur, i)=>i===activeFeaturedSelectionKey ? cur : acc, null) || this.props.activeFeaturedSelection;
        let oEvent = {
            preventDefault: () => {/* noop */},
            currentTarget: {
                pathname: '/catalog/product/' + newActiveFeaturedSelection.id + '-' + newActiveFeaturedSelection.url
            }
        }
        this.props.dispatch([setActiveFeaturedSelection( newActiveFeaturedSelection ), navigate(oEvent, false)]);

    }

    closeModal(){
        let {dispatch, activeFilter, activeProduct, activeFilterResult } = this.props;

        dispatch( [setActiveFeaturedSelection(), closeModal()] );
        if( typeof window !== 'undefined' && window.history )
            window.history.back();
        else {
            let pathname;
            if(activeProduct.id)
                pathname = '/catalog/product/' + activeProduct.id + '-' + activeProduct.url;
            else if(this.props.activeFilter == "category" || this.props.activeFilter == "genre")
                pathname = '/catalog/'+ activeFilter+'/'+ activeFilterResult.id + '-' + activeFilterResult.url;
            else
                pathname = '/catalog';
            let oEvent = {
                preventDefault: () => {/* noop */},
                currentTarget: {
                    pathname: pathname
                }
            };
            dispatch(navigate(oEvent, false));
        }
    }


    render() {
        let {dispatch} = this.props;
        let leftPointer = "";
        let rightPointer = "";
        if (this.props.featured.length > 1) {
          leftPointer = (
            <div
                className={"pointer left"}
                onClick={this.stepThroughFeaturedSelections.bind(this,"backward")}
            >
                <svg version="1.1"x="0px" y="0px" width="18.25px" height="34px" viewBox="0 0 18.25 34" enableBackground="new 0 0 18.25 34">
                    <polygon fill="rgba(255,255,255,.5)" points="17.157,0.343 0.257,17.244 17.014,34 18.029,32.985 2.288,17.243 18.172,1.357 "/>
                </svg>
            </div>
          );
          rightPointer = (
            <div
                className={"pointer right"}
                onClick={this.stepThroughFeaturedSelections.bind(this, "forward")}
            >
                <svg version="1.1" x="0px" y="0px" width="18.25px" height="34px" viewBox="0 0 18.25 34" enableBackground="new 0 0 18.25 34">
                    <polygon fill="rgba(255,255,255,.5)" points="1.35,34.001 18.25,17.1 1.493,0.344 0.478,1.358 16.22,17.101 0.335,32.986 "/>
                </svg>
            </div>
          );
        }

        return (
            <div className="modal-window featured-selection full-width">
              <div className={"modal-close"} onClick={this.closeModal.bind(this)}>&times;</div>
              {leftPointer}
              {rightPointer}
              <ProductDetail modal={(this.props.activeModal) ? true : false} />
            </div>
        );
    }
};

function mapStateToProps(state){
    return {
        'featured': state.featured,
        'activeFilter': state.activeFilter,
        'activeFilterResult': state.activeFilterResult,
        'activeProduct': state.activeProduct,
        'activeFeaturedSelection': state.activeFeaturedSelection,
        'products': state.products,
        'activeModal': state.activeModal,
        'storeType': state.store.type
    };
}

export default connect(mapStateToProps)(ModalFeaturedSelection);



// WEBPACK FOOTER //
// ./src/components/ModalFeaturedSelection.jsx